import React, { useRef } from 'react';
import QRCode from 'qrcode.react';
import ReactToPrint from 'react-to-print';
import { Button, Card } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';

const PrintableQRCode = React.forwardRef(({ value, size = 300, title, description }, ref) => (
	<div ref={ref} style={{ padding: '20px', textAlign: 'center' }}>
		<div className="mb-8 text-3xl font-bold ">{title}</div>
		<QRCode value={value} size={size} />
		<div className="mt-4 text-2xl ">{description}</div>
		<footer className="fixed inset-x-0 bottom-0 ">
			<div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 md:flex md:items-center md:justify-center lg:px-8">
				<nav className="-mx-5 -my-2 flex flex-wrap justify-center" aria-label="Footer">
					<div className="px-5 py-2">
						<span className="text-lg text-black hover:text-gray-300">
							Powered by{' '}
							<img
								className="ml-1 h-6 w-auto "
								src="https://emptor-data-assets.s3.amazonaws.com/images/openwrench-logos/openwrench-new-logo-black.svg"
								alt=""
							/>
						</span>
					</div>
				</nav>
			</div>
		</footer>
	</div>
));

const QRCodePrinter = ({ value, children, title, description, cardTitle }) => {
	const qrRef = useRef();

	return (
		<Card
			title={cardTitle}
			style={{ height: '100%' }}
			extra={
				<ReactToPrint
					trigger={() => <Button icon={<PrinterOutlined />} type="ghost" shape="circle" />}
					content={() => qrRef.current}
					pageStyle={`
                        @page {
                          size: auto;
                          margin: 0mm; 
                        }
                    
                        body {
                          margin: 0;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        }
                      `}
				/>
			}
		>
			<div className=" flex h-full flex-col items-center justify-center">
				<div className="hidden print:block">
					<PrintableQRCode ref={qrRef} value={value} title={title} description={description} />
				</div>
				<div>
					<QRCode value={value} size={200} />
				</div>
				{children}
			</div>
		</Card>
	);
};

export default QRCodePrinter;
